"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/chips/dist/mdc.chips.css");
require("@rmwc/icon/styles");
require("@rmwc/ripple/styles");
